import { render, staticRenderFns } from "./remindDialogCommon.vue?vue&type=template&id=c33b38c2&scoped=true&"
import script from "./remindDialogCommon.vue?vue&type=script&lang=js&"
export * from "./remindDialogCommon.vue?vue&type=script&lang=js&"
import style0 from "./remindDialogCommon.vue?vue&type=style&index=0&id=c33b38c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b38c2",
  null
  
)

export default component.exports